import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e3e8bf70"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flight-progress-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            style: _normalizeStyle(_ctx.backgroundProgress),
            class: "flight-progress-background"
        }, null, 4),
        _createElementVNode("img", {
            src: "svg/flight.svg",
            style: _normalizeStyle(_ctx.iconProgress),
            class: "flight-progress-icon",
            alt: "flight icon"
        }, null, 4)
    ]));
}
